import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, CircularProgress, Stack } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { useIntl } from "react-intl";
import RevaText from "components/common/RevaText";
import { teamImageUrl } from "./team-image-helpers";

const TeamImageUpload = ({
  team,
  imageUrl: imageUrlOverride,
  onFileSelect,
  uploading = false,
  disabled = false,
  saveFirst = false,
}) => {
  const intl = useIntl();
  const [localPreview, setLocalPreview] = useState(null);
  const imageUrl = imageUrlOverride ?? teamImageUrl(team);

  useEffect(() => {
    if (!uploading) {
      setLocalPreview(null);
    }
  }, [imageUrl, uploading]);

  const handleChange = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file || disabled || uploading) return;

    const reader = new FileReader();
    reader.onloadend = () => setLocalPreview(reader.result);
    reader.readAsDataURL(file);
    onFileSelect?.(file);
  };

  return (
    <Stack alignItems="center" spacing={1.5} sx={{ py: 1 }}>
      <Avatar
        src={localPreview || imageUrl || undefined}
        alt={team?.name || ""}
        variant="rounded"
        sx={{
          width: 96,
          height: 96,
          bgcolor: "action.hover",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {!localPreview && !imageUrl ? team?.short_name?.slice(0, 2)?.toUpperCase() || "?" : null}
      </Avatar>
      <Box>
        <Button
          component="label"
          variant="outlined"
          size="small"
          startIcon={uploading ? <CircularProgress size={16} /> : <UploadIcon />}
          disabled={disabled || uploading}
        >
          {intl.formatMessage({ id: "gestion.teams.uploadCrest" })}
          <input hidden type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={handleChange} />
        </Button>
      </Box>
      <RevaText variant="caption" color="text.secondary" textAlign="center">
        {intl.formatMessage({
          id: saveFirst ? "gestion.teams.crestSaveFirst" : "gestion.teams.crestHint",
        })}
      </RevaText>
    </Stack>
  );
};

export default TeamImageUpload;
